// extracted by mini-css-extract-plugin
module.exports = {"artboard":"certificate_artboard__1cHvU"};